import { Component, OnInit } from '@angular/core';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { Model, StylesManager, SurveyNG } from "survey-angular";
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';

StylesManager.applyTheme("modern");

@Component({
  selector: 'app-baseline',
  templateUrl: './baseline.component.html',
  styleUrls: ['./baseline.component.scss']
})
export class BaselineComponent implements OnInit {

  public city = history.state.city;
  public step: string = 'Baseline';
  public questionnaire: any = [];

  constructor(private req: HttpRequestsService<any>, private _location: Location) { }

  ngOnInit(): void {
    this.req.getEvaluationQuestionnaire(this.step).subscribe((res) => {
      this.questionnaire = res;
      //hardcoded but maintainable (questions willnot change)
      const json = {
        showProgressBar: "top",
        requiredText: "",
        pages: [
          {
            "elements": [
              {
                "type": "matrix",
                "isAllRowRequired": true,
                "title": `${this.questionnaire[0].Tag}`,
                "columns": [
                  {
                    "value": 1,
                    "text": "Very Bad"
                  },
                  {
                    "value": 2,
                    "text": "Poor"
                  },
                  {
                    "value": 3,
                    "text": "Regular"
                  },
                  {
                    "value": 4,
                    "text": "Good"
                  },
                  {
                    "value": 5,
                    "text": "Excellent"
                  },
                  {
                    "value": 0,
                    "text": "Don't Know / Not applicable"
                  }
                ],
                "rows": [{ text: `1. ${this.questionnaire[0].LQs[0]}` },
                { text: `2. ${this.questionnaire[0].LQs[1]}` },
                { text: `3. ${this.questionnaire[0].LQs[2]}` },
                { text: `4. ${this.questionnaire[0].LQs[3]}` }
                ]
              }
            ]
          },
          {
            "elements": [
              {
                "type": "matrix",
                "isAllRowRequired": true,
                "title": `${this.questionnaire[1].Tag}`,
                "columns": [
                  {
                    "value": 1,
                    "text": "Very Bad"
                  },
                  {
                    "value": 2,
                    "text": "Poor"
                  },
                  {
                    "value": 3,
                    "text": "Regular"
                  },
                  {
                    "value": 4,
                    "text": "Good"
                  },
                  {
                    "value": 5,
                    "text": "Excellent"
                  },
                  {
                    "value": 0,
                    "text": "Don't Know / Not applicable"
                  }
                ],
                "rows": [{ text: `1. ${this.questionnaire[1].LQs[0]}` },
                { text: `2. ${this.questionnaire[1].LQs[1]}` },
                { text: `3. ${this.questionnaire[1].LQs[2]}` },
                { text: `4. ${this.questionnaire[1].LQs[3]}` },
                { text: `5. ${this.questionnaire[1].LQs[4]}` }
                ]
              }
            ]
          },
          {
            "elements": [
              {
                "type": "matrix",
                "isAllRowRequired": true,
                "title": `${this.questionnaire[2].Tag}`,
                "columns": [
                  {
                    "value": 1,
                    "text": "Very Bad"
                  },
                  {
                    "value": 2,
                    "text": "Poor"
                  },
                  {
                    "value": 3,
                    "text": "Regular"
                  },
                  {
                    "value": 4,
                    "text": "Good"
                  },
                  {
                    "value": 5,
                    "text": "Excellent"
                  },
                  {
                    "value": 0,
                    "text": "Don't Know / Not applicable"
                  }
                ],
                "rows": [{ text: `1. ${this.questionnaire[2].LQs[0]}` },
                { text: `2. ${this.questionnaire[2].LQs[1]}` },
                { text: `3. ${this.questionnaire[2].LQs[2]}` },
                { text: `4. ${this.questionnaire[2].LQs[3]}` },
                { text: `5. ${this.questionnaire[2].LQs[5]}` },
                { text: `6. ${this.questionnaire[2].LQs[6]}` },
                { text: `7. ${this.questionnaire[2].LQs[7]}` },
                { text: `8. ${this.questionnaire[2].LQs[8]}` },
                { text: `9. ${this.questionnaire[2].LQs[9]}` },
                { text: `10. ${this.questionnaire[2].LQs[10]}` },
                ]
              },
              // {
              //   "type": "radiogroup",
              //   "title": `${this.questionnaire[2].LQs[4]}`,
              //   "name": "shouldShow0",
              //   "choices": ["Yes", "No"],
              // },
              // {
              //   "type": "text",
              //   "name": "Please specify.",
              //   "visibleIf": "{shouldShow0}='Yes'",
              // }
            ]
          },
          {
            "elements": [
              {
                "type": "matrix",
                "isAllRowRequired": true,
                "title": `${this.questionnaire[3].Tag}`,
                "columns": [
                  {
                    "value": 1,
                    "text": "Very Bad"
                  },
                  {
                    "value": 2,
                    "text": "Poor"
                  },
                  {
                    "value": 3,
                    "text": "Regular"
                  },
                  {
                    "value": 4,
                    "text": "Good"
                  },
                  {
                    "value": 5,
                    "text": "Excellent"
                  },
                  {
                    "value": 0,
                    "text": "Don't Know / Not applicable"
                  }
                ],
                "rows": [{ text: `1. ${this.questionnaire[3].LQs[0]}` },
                { text: `2. ${this.questionnaire[3].LQs[1]}` },
                { text: `3. ${this.questionnaire[3].LQs[2]}` },
                { text: `4. ${this.questionnaire[3].LQs[3]}` },
                { text: `5. ${this.questionnaire[3].LQs[4]}` }
                ]
              }
            ]
          },
          {
            "elements": [
              {
                "type": "matrix",
                "isAllRowRequired": true,
                "title": `${this.questionnaire[4].Tag}`,
                "columns": [
                  {
                    "value": 1,
                    "text": "Very Bad"
                  },
                  {
                    "value": 2,
                    "text": "Poor"
                  },
                  {
                    "value": 3,
                    "text": "Regular"
                  },
                  {
                    "value": 4,
                    "text": "Good"
                  },
                  {
                    "value": 5,
                    "text": "Excellent"
                  },
                  {
                    "value": 0,
                    "text": "Don't Know / Not applicable"
                  }
                ],
                "rows": [{ text: `1. ${this.questionnaire[4].LQs[0]}` },
                { text: `2. ${this.questionnaire[4].LQs[1]}` },
                { text: `3. ${this.questionnaire[4].LQs[2]}` },
                { text: `4. ${this.questionnaire[4].LQs[3]}` },
                { text: `5. ${this.questionnaire[4].LQs[4]}` }
                ]
              }
            ]
          },
          {
            "elements": [
              {
                "type": "matrix",
                "isAllRowRequired": true,
                "title": `${this.questionnaire[5].Tag}`,
                "columns": [
                  {
                    "value": 1,
                    "text": "Very Bad"
                  },
                  {
                    "value": 2,
                    "text": "Poor"
                  },
                  {
                    "value": 3,
                    "text": "Regular"
                  },
                  {
                    "value": 4,
                    "text": "Good"
                  },
                  {
                    "value": 5,
                    "text": "Excellent"
                  },
                  {
                    "value": 0,
                    "text": "Don't Know / Not applicable"
                  }
                ],
                "rows": [{ text: `1. ${this.questionnaire[5].LQs[0]}` },
                { text: `2. ${this.questionnaire[5].LQs[1]}` },
                { text: `3. ${this.questionnaire[5].LQs[2]}` },
                { text: `4. ${this.questionnaire[5].LQs[3]}` },
                { text: `5. ${this.questionnaire[5].LQs[4]}` }
                ]
              }
            ]
          },
          {
            "elements": [
              {
                "type": "matrix",
                "isAllRowRequired": true,
                "title": `${this.questionnaire[6].Tag}`,
                "columns": [
                  {
                    "value": 1,
                    "text": "Very Bad"
                  },
                  {
                    "value": 2,
                    "text": "Poor"
                  },
                  {
                    "value": 3,
                    "text": "Regular"
                  },
                  {
                    "value": 4,
                    "text": "Good"
                  },
                  {
                    "value": 5,
                    "text": "Excellent"
                  },
                  {
                    "value": 0,
                    "text": "Don't Know / Not applicable"
                  }
                ],
                "rows": [{ text: `1. ${this.questionnaire[6].LQs[0]}` },
                { text: `2. ${this.questionnaire[6].LQs[1]}` },
                { text: `3. ${this.questionnaire[6].LQs[2]}` },
                { text: `4. ${this.questionnaire[6].LQs[3]}` },
                { text: `5. ${this.questionnaire[6].LQs[4]}` }
                ]
              }
            ]
          },
          {
            "elements": [
              {
                "type": "matrix",
                "isAllRowRequired": false,
                "title": `${this.questionnaire[7].Tag}`,
                "columns": [
                  {
                    "value": 1,
                    "text": "Very Bad"
                  },
                  {
                    "value": 2,
                    "text": "Poor"
                  },
                  {
                    "value": 3,
                    "text": "Regular"
                  },
                  {
                    "value": 4,
                    "text": "Good"
                  },
                  {
                    "value": 5,
                    "text": "Excellent"
                  },
                  {
                    "value": 0,
                    "text": "Don't Know / Not applicable"
                  }
                ],
                "rows": [{ text: `1. ${this.questionnaire[7].LQs[0]}` },
                { text: `2. ${this.questionnaire[7].LQs[1]}` },
                { text: `3. ${this.questionnaire[7].LQs[2]}` }
                ]
              }
            ]
          },
          {
            "elements": [
              {
                "type": "matrix",
                "isAllRowRequired": true,
                "title": `${this.questionnaire[8].Tag}`,
                "columns": [
                  {
                    "value": 1,
                    "text": "Very Bad"
                  },
                  {
                    "value": 2,
                    "text": "Poor"
                  },
                  {
                    "value": 3,
                    "text": "Regular"
                  },
                  {
                    "value": 4,
                    "text": "Good"
                  },
                  {
                    "value": 5,
                    "text": "Excellent"
                  },
                  {
                    "value": 0,
                    "text": "Don't Know / Not applicable"
                  }
                ],
                "rows": [{ text: `1. ${this.questionnaire[8].LQs[1]}` },
                { text: `2. ${this.questionnaire[8].LQs[2]}` },
                { text: `3. ${this.questionnaire[8].LQs[3]}` },
                { text: `4. ${this.questionnaire[8].LQs[4]}` },
                { text: `5. ${this.questionnaire[8].LQs[5]}` },
                { text: `6. ${this.questionnaire[8].LQs[6]}` }
                ]
              },
              // {
              //   "type": "matrix",
              //   "title": `${this.questionnaire[8].LQs[0]}`,
              //   "name": "shouldShow1",
              //   "columns": [
              //     {
              //       "value": 1,
              //       "text": "Yes"
              //     },
              //     {
              //       "value": 0,
              //       "text": "No"
              //     },
              //   ]
              // },
            ]
          }
        ]
      }//end of json

      const survey = new Model(json);

      SurveyNG.render("questionnaireContainer", { model: survey });

      survey.completedHtml = "<span>Evaluation survey completed! Thank you for your time and feedback!</span>";
      survey.onCompleting.add(function (sender) {

        var city = history.state.city;
        var dataObj = JSON.stringify(sender.data);
        const xhr = new XMLHttpRequest();
        const url = environment.apiType + '://' + environment.apiUrl;

        xhr.open("POST", `${url}/api/v2/evaluation?city=${city}&step=Baseline`);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.send(JSON.stringify(dataObj));
      })

      survey.onComplete.add(() =>
        setTimeout(() => {
          this._location.back()
        }, 2000));
    })
  }
};

